// extracted by mini-css-extract-plugin
module.exports = {"footer":"BraintreePaymentForm_footer__25msM","spinnerWrapper":"BraintreePaymentForm_spinnerWrapper__2F3cC"};